import React from "react";
import { Typography } from "@material-ui/core";
import { IconName, Icon } from "halifax";
import styles from "./styles.module.scss";
import clsx from "clsx";

export interface IVacationRentalTermsOfServiceLinkProps {
  vacationRentalListingTermsOfServiceUrl?: string;
  className?: string;
}

export const VacationRentalTermsOfServiceLink = ({
  vacationRentalListingTermsOfServiceUrl,
  className,
}: IVacationRentalTermsOfServiceLinkProps) => {
  if (!vacationRentalListingTermsOfServiceUrl) {
    return null;
  }

  return (
    <Typography
      variant="body2"
      className={clsx(styles["terms-and-conditions-text"], className)}
    >
      By proceeding with this reservation, I acknowledge that I have reviewed
      and accept the{" "}
      <a
        href={vacationRentalListingTermsOfServiceUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={styles["terms-and-conditions-link"]}
      >
        Terms of Service
        <Icon
          name={IconName.LinkOut}
          className={styles["terms-and-conditions-link-icon"]}
        />
      </a>
    </Typography>
  );
};
